var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top_wrap",on:{"click":function($event){return _vm.toTop()}}},[_c('p',{staticClass:"link",attrs:{"href":"#"}})])}
var staticRenderFns = []

export { render, staticRenderFns }